import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { lastValueFrom } from 'rxjs';
import { ItOpsControllerService } from 'src/app/admin-api/api/itOpsController.service';
import { AppDialogService } from 'src/app/services/dialog.service';
import { LoaderService } from 'src/app/services/loader.service';

@Component({
  selector: 'app-integrity-view',
  templateUrl: './integrity-view.component.html',
  styleUrls: ['./integrity-view.component.scss']
})
export class IntegrityViewComponent implements OnInit {
  rows: any[] = [];
  columns: string[] = [];
  loading = true;

  constructor(
    private route: ActivatedRoute,
    private itOpsService: ItOpsControllerService
  ) {}

  async ngOnInit() {
    const id = +this.route.snapshot.paramMap.get('id')!;
    try {
      LoaderService.showLoader();
      const res = await lastValueFrom(this.itOpsService.executeIntegrity(id));
      const data = res?.result || [];
      if (data.length > 0) {
        this.columns = data[0]['map']((_: any, i: number) => `Coluna ${i + 1}`);
      }
      this.rows = Array.isArray(data) ? data : [data];
    } catch (err) {
      console.error('Erro ao buscar dados da integridade', err);
      AppDialogService.showErrorDialog(err);
    } finally {
      this.loading = false;
      LoaderService.showLoader(false);
    }
  }
}
